import PropTypes from 'prop-types';
import { BiDotsVerticalRounded } from 'react-icons/bi';

const WorkReportLineMenu = ({ setShowModalMenu, showModalMenu }) => (
  <button
    aria-label="Menu"
    className="button_work_report_menu"
    disabled={false}
    onClick={() => {
      setShowModalMenu(!showModalMenu);
    }}
    type="button"
  >
    <BiDotsVerticalRounded />
  </button>
);

WorkReportLineMenu.propTypes = {
  setShowModalMenu: PropTypes.func.isRequired,
  showModalMenu: PropTypes.bool.isRequired
};

export default WorkReportLineMenu;
